module.exports = __webpack_public_path__ + "img/icon_visit_registry.557f05fb.svg";